/**
 * Shared keys for carrying the crop-season selection from the product-scoped
 * Production Records view to the season-scoped Applications list.
 *
 * Kept in one place so the producer (the View link's `?seasonIds`), the two
 * seeders (the bootstrap seed for a new tab and the link onClick for same-tab),
 * the reader (useSelectedCropSeasonIds), and the destination strip can't drift
 * apart — e.g. a rename here updates every side at once instead of silently
 * breaking the seed or leaving the param un-stripped.
 */
export const SELECTED_CROP_SEASONS_STORAGE_KEY = 'selectedCropSeasons';
export const SEASON_IDS_PARAM = 'seasonIds';
